import { createRoute } from '@tanstack/solid-router'
import { rootRoute } from './__root'
import { AppShell } from '../AppShell'

// Pathless layout-route — монтируется один раз, держит Rail/Sidebar/Topbar
// и DnD/keyboard hooks в DOM. Все экраны приложения — дети этого роута;
// смена URL внутри _appLayout не размонтирует Shell, только меняет содержимое
// в <Outlet/>.
//
// Auth-guard сюда не вешаем — AuthGate сидит выше RouterProvider в App.tsx
// (auth — состояние всего приложения, не отдельной ветки роутов).
export const appLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_appLayout',
  component: AppShell,
})
